import SearchGroup from './containers/search_group/SearchGroup';
import { useState } from 'react';
import TablePage from './containers/table_page/TablePage';
import ModalML from '@/components/modal_ml/ModalML';
import './index.less';
import AddRule from './containers/add_rule/AddRule';
import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'dva';
import { message } from 'antd';

const RuleEngine = (props) => {
  const { id, editable } = props.location.query;
  const dispatch = useDispatch();
  const [searchVal, setSearchVal] = useState({});
  const [idArr, setIdArr] = useState([]);
  const [addVisble, setAddVisble] = useState(false);
  const [parents, setParents] = useState({});
  const [handleStatus, setHandleStatus] = useState('add');
  const handleSearch = (Val) => {
    setSearchVal({ ...Val });
  };

  const handleOk = () => {};
  const handleCancel = () => {
    setAddVisble(false);
  };
  //添加编辑规则
  const addRuleChange = (record, status) => {
    setAddVisble(true);
    if (record) {
      setParents(record);
      setHandleStatus(status);
    } else {
      setParents({});
      setHandleStatus('add');
    }
  };

  // 发起请求
  const fetchData = useCallback(() => {
    dispatch({
      type: 'ruleManageDetail/getRuleDetailList',
      payload: {
        values: {
          ruleBlockId: id,
          ...searchVal,
        },
      },
      callback: () => {
        setIdArr([]);
      },
    });
  }, [dispatch, id, searchVal]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  //批量删除
  const handleDelete = () => {
    if (!idArr.length) {
      message.warning('请选择删除项');
      return;
    }

    dispatch({
      type: 'ruleManageDetail/deleteBatchRuleManaList',
      payload: {
        values: {
          ruleOutputResultIds: idArr,
        },
      },
      callback: () => {
        message.success('删除成功');
        fetchData();
      },
    });
  };
  //批量删除的数组
  const handleDeleteSel = (ids) => {
    setIdArr(ids);
  };
  return (
    <div className="re">
      <div className="contain">
        <SearchGroup
          {...props}
          handleSearch={(Val) => handleSearch(Val)}
          addRuleChange={addRuleChange}
          handleDelete={handleDelete}
          id={id}
        />
        <TablePage
          params={searchVal}
          addRuleChange={addRuleChange}
          fetchData={fetchData}
          handleDeleteSel={handleDeleteSel}
          editable={editable}
        />
      </div>
      <ModalML
        title=""
        visible={addVisble}
        handleOk={handleOk}
        handleCancel={handleCancel}
      >
        <AddRule
          handleOk={handleOk}
          handleCancel={handleCancel}
          fetchData={fetchData}
          parents={parents}
          handleStatus={handleStatus}
          id={id}
        />
      </ModalML>
    </div>
  );
};

export default RuleEngine;
